import "../../../static/js/loaders/jquery";
$('.FormChoice__Input:not(.NoFormChoiceWrap)').each(function () {
    $(this).add($(this).next()).wrapAll('<div class="form-check"></div>');
});